import { TitleCasePipe } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SonaUsageFacade } from '@sona/angular-auth-api';
import { BadgeVariants, HlmBadgeDirective } from '@spartan-ng/ui-badge-helm';
import { HlmSkeletonComponent } from '@spartan-ng/ui-skeleton-helm';

@Component({
    selector: 'sona-current-plan-badge',
    standalone: true,
    imports: [
        TranslatePipe,
        TitleCasePipe,
        HlmBadgeDirective,
        HlmSkeletonComponent
    ],
    template: `
        @if (usageFacade.hasValue()) {
            <div
                hlmBadge
                static
                [variant]="isTrialing() ? 'accent-amber' : 'accent-green'"
                [size]="size()"
            >
                {{ currentPlan() | titlecase }}
                @if (isTrialing()) {
                    {{ 'PAYMENTS.COMPONENT.PLAN_BADGE.TRIAL' | translate }}
                }
            </div>
        } @else {
            <hlm-skeleton class="tw-h-5 tw-w-16 tw-rounded-full" />
        }
    `,
    host: {
        class: 'tw-contents'
    }
})
export class SonaCurrentPlanBadgeComponent {

    protected readonly usageFacade = inject(SonaUsageFacade);

    readonly size = input<BadgeVariants['size']>('default');

    protected readonly currentPlan = computed(() => this.usageFacade.usage()?.subscription.plan);
    protected readonly currentStatus = computed(() => this.usageFacade.usage()?.subscription.status);
    protected readonly isTrialing = computed(() => this.currentStatus() === 'trialing');
}
